import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/tmp/build_3ce305fc/layouts/auth.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/tmp/build_3ce305fc/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/tmp/build_3ce305fc/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/tmp/build_3ce305fc/layouts/empty.vue").then(m => m.default || m)),
  map: defineAsyncComponent(() => import("/tmp/build_3ce305fc/layouts/map.vue").then(m => m.default || m))
}